import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  width: 40%;
  height: 5rem;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  border-radius: 20px;

  background-color: ${props => props.theme.colors.card_300};
  transition: 200ms ease;
  
  border-color: ${props => props.theme.colors.border_grey};
  left: 50%;
  bottom: -30px;
  transform: translate(-50%, -50%);

  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

`;


